/**
 * Internacionalização (i18n) para OptiSaaS
 * Mensagens de erro e textos em Português do Brasil
 */

export const ptBR = {
  // Autenticação
  auth: {
    emailSenhaIncorretos: 'Email ou senha incorretos.',
    emailNaoConfirmado: 'Confirme seu email antes de entrar.',
    muitasTentativas: 'Muitas tentativas. Aguarde 1 minuto e tente novamente.',
    falhaConexao: 'Falha de conexão. Verifique internet e variáveis do Supabase.',
    perfilNaoEncontrado: 'Conta sem perfil no sistema. Fale com o suporte para vincular seu usuário.',
    tenantNaoEncontrado: 'Conta sem tenant vinculado. Fale com o suporte para corrigir o cadastro.',
    semPermissao: 'Sem permissão para acessar os dados. Verifique as políticas de segurança (RLS).',
    sessaoExpirada: 'Sessão expirada. Tente novamente.',
    contaBloqueada: 'Conta bloqueada. Entre em contato com o suporte.',
    contaPendente: 'Conta aguardando aprovação do administrador.',
    erroDesconhecido: 'Erro desconhecido. Tente novamente.',
  },
  // Erros genéricos
  errors: {
    erroAoCarregar: 'Erro ao carregar dados.',
    erroAoSalva: 'Erro ao salvar dados.',
    erroAoExcluir: 'Erro ao excluir dados.',
    erroAoAtualizar: 'Erro ao atualizar dados.',
    sessaoExpirada: 'Sessão expirada. Faça login novamente.',
    preenchaObrigatorios: 'Preencha os campos obrigatórios antes de salvar.',
    semPermissaoTenant: 'Sem permissão para salvar neste tenant. Saia e entre novamente.',
  },
  // Validações
  validation: {
    campoObrigatorio: 'Campo obrigatório',
    emailInvalido: 'Email inválido',
    senhaCurta: 'A senha deve ter no mínimo 6 caracteres',
    senhasDiferentes: 'As senhas não coincidem',
  },
  // Ações
  actions: {
    salvando: 'Salvando...',
    salvoComSucesso: 'Salvo com sucesso!',
    excluindo: 'Excluindo...',
    excluidoComSucesso: 'Excluído com sucesso!',
    carregando: 'Carregando...',
    erroAoSalvar: 'Erro ao salvar',
    erroAoExcluir: 'Erro ao excluir',
  },
  // Financeiro
  finance: {
    semPermissaoFinanceiro: 'Apenas OWNER e MANAGER podem gerenciar o financeiro.',
  },
} as const;

export type PtBR = typeof ptBR;

/**
 * Recupera uma mensagem do dicionário usando notação de ponto
 * @example t('auth.emailSenhaIncorretos')
 */
export const t = (path: string): string => {
  const keys = path.split('.');
  let current: unknown = ptBR;

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return path;
    }
  }

  return typeof current === 'string' ? current : path;
};

export { ptBR as default };
